import { render, staticRenderFns } from "./CardPost.vue?vue&type=template&id=0fca52a0&"
import script from "./CardPost.vue?vue&type=script&lang=js&"
export * from "./CardPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports